import { MdDescription } from 'react-icons/md';
import type SharedAttachedFile from '@/types/serializers/SharedAttachedFile';
import { isImageContentType } from '@/utils/chatAttachments';

interface ChatMessageAttachmentsProps {
  attachments: SharedAttachedFile[];
  isOwn: boolean;
}

export default function ChatMessageAttachments({
  attachments,
  isOwn,
}: ChatMessageAttachmentsProps) {
  if (attachments.length === 0) return null;

  return (
    <div className={`flex flex-col gap-xs ${isOwn ? 'items-end' : 'items-start'}`}>
      {attachments.map((attachment) =>
        isImageContentType(attachment.content_type) ? (
          <a
            key={attachment.id}
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <img
              src={attachment.url}
              alt={attachment.filename}
              className="max-h-48 max-w-[240px] rounded-md border border-solid border-border object-cover"
            />
          </a>
        ) : (
          <a
            key={attachment.id}
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            title={attachment.filename}
            className="flex max-w-[240px] items-center gap-xxs rounded-sm border border-solid border-border bg-white px-sm py-xs text-main no-underline"
          >
            <MdDescription className="size-5 shrink-0" />
            <span className="min-w-0 truncate text-button-md">{attachment.filename}</span>
          </a>
        )
      )}
    </div>
  );
}
